import * as cn from "classnames";
import * as React from "react";
import "./ProgressChart.css";

export interface ProgressChartProps {
    progress: number;

    className?: string;

    progressColor?: string;
    bgColor?: string;
    roundCorner?: boolean;
}

export function ProgressChart(props: ProgressChartProps) {
    const progressStyle: React.CSSProperties = { backgroundColor: props.bgColor || "" };
    if (props.bgColor) {
        progressStyle.backgroundColor = props.bgColor;
    }

    const innerProgressStyle: React.CSSProperties = {
        width: `${Math.max(0, Math.min(props.progress, 100))}%`
    };
    if (props.progressColor) {
        innerProgressStyle.backgroundColor = props.progressColor;
    }

    return (
        <div className={cn("ProgressChart", props.className)} style={progressStyle}>
            <div
                className={cn("ProgressChart__inner", { "round-corners": props.roundCorner !== false })}
                style={innerProgressStyle}
            />
        </div>
    );
}
